<template>
  <FormRow class="designation" inline>
    <FormCol field="applications.0.department" :showLabel="false">
          <FormSelect>
      <option value="NCSY_Atlanta">Atlanta</option>
      <option value="NCSY_AtlanticSeaboard">Atlantic Seaboard</option>
      <option value="NCSY_Canada">Canada</option>
      <option value="NCSY_CentralEast">Central East</option>
      <option value="NCSY_Midwest">Midwest</option>
      <option value="NCSY">National</option>
      <option value="NCSY_Tristate">New Jersey</option>
      <option value="NCSY_Tristate">New York</option>
      <option value="NCSY_NewEngland">Northeast (New England &amp; Upstate)</option>
      <option value="NCSY_Portland">Oregon</option>
      <option value="NCSY_Southern">Southern</option>
      <option value="NCSY_Southwest">Southwest</option>
      <option value="NCSY_WestCoast">West Coast</option>
    </FormSelect>

    </FormCol>
  </FormRow>
  </template>
  <script lang="ts">
  import {
    defineComponent,
    watch
  } from 'vue'
  import { usePaymentForm } from '~/shared/use-payment-form'
  
  export default defineComponent({
    setup() {
      const { getValue, setValue } = usePaymentForm()

      return {
        getValue,
        setValue
      }
    },
  })
  </script>
  <style scoped lang="scss">
  .designation {
    display: flex;
    width: 100%;
    position: relative;
    ::v-deep select {
      flex: 1;
      min-width:50%;
      max-width:50%;
      margin-right: 1%;
    }
    ::v-deep select:last-child {
      margin-right: 0;
    }
  }
  </style>
  